import React, { useState, useMemo } from "react";
import { loadReCaptcha, ReCaptcha } from "react-recaptcha-v3";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt, faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const recaptchaApiKey = "6LdazMAUAAAAAEoS7OsGk0nmydBBL1V4YykXDD-9";

const axios = require("axios"),
  {
    serverURL,
    onSignInURL,
    hideNav,
    axiosConfig,
    // isBrowser: { pingdom, safari }
  } = require("./_util"),
  loginUrl = serverURL + "/login",
  registerUrl = serverURL + "/register";

export const SignInLocationReplace = () => {
  window.document.location.replace(process.env.PUBLIC_URL + "/sign-in");
};

export const HomePageLocationReplace = () => {
  window.document.location.replace(process.env.PUBLIC_URL + "/");
}

export const SignIn = () => {

  useMemo(async () => {
    if (localStorage.getItem("token")) window.document.location.assign("/session/");
  }, []);

  if (
    window.document.location.protocol !== "https:" &&
    window.document.location.hostname !== "localhost"
  )
    window.document.location.protocol = "https:";

  hideNav();
  loadReCaptcha(recaptchaApiKey);

  const [email, setEmail] = useState(""),
    [emailNew, setEmailNew] = useState(""),
    [password, setPassword] = useState(""),
    [loginFailed, setLoginFailed] = useState(false),
    [tsCs, setTcCs] = useState(false),
    [haventAgreed, setHaventAgreed] = useState(false),
    [recaptcha, setRecaptcha] = useState(""),
    hostname = window.document.location.hostname,
    isLatest = !!(hostname === "latest.speakunique.co.uk"),
    isLocalhost = !!(hostname === "localhost"),
    showVolunteerRegLink = !!(isLatest || isLocalhost),
    sendSubmit = e => {
      e.preventDefault();
      localStorage.clear();

      const postData = { email, password, recaptcha };
      axios
        .post(loginUrl, postData, axiosConfig)
        .then(response => {
          response = response.data;

          if (!(response && response.ok && response.token)) {
            setLoginFailed(true);
            return;
          }

          localStorage.setItem("token", response.token);
          let nextUrl = onSignInURL;

          if (typeof response.voiceDetails !== "undefined") {
            const {
              medicalConditionOrSaveVoice,
              speechAffected,
              regionalAccent,
              product
            } = response.voiceDetails,
              paid = response.pd;

            if (product === "Volunteer") {
              nextUrl = nextUrl; // volunteers are ok, just let them go to the homepage, not product selction
            } else {
              if (typeof medicalConditionOrSaveVoice !== "undefined") {
                if (medicalConditionOrSaveVoice.length === 0) {
                  // unset circumstance: they should go to the boxes page
                  nextUrl = "/session/service"; // default is screen 1, the four boxes
                } else if (
                  medicalConditionOrSaveVoice === "Medical condition"
                ) {
                  if (typeof speechAffected !== "undefined" && !!speechAffected) {
                    if (speechAffected.length === 0) {
                      // medical, but no data on effect. they should go to the diagnosis page
                      localStorage.setItem("setStage", "3");
                      nextUrl = "/session/mc";
                    } else if (
                      !regionalAccent ||
                      typeof regionalAccent === "undefined" ||
                      `${regionalAccent || ""}`.length === 0
                    ) {
                      // medical but no data on accent. they should go to the accent page.
                      localStorage.setItem("setStage", "2");
                      nextUrl = "/session/accent";
                    }
                  }
                } else if (
                  medicalConditionOrSaveVoice === "SLT" ||
                  medicalConditionOrSaveVoice === "Save my voice"
                ) {
                  if (
                    !regionalAccent ||
                    typeof regionalAccent === "undefined" ||
                    regionalAccent.length === 0
                  ) {
                    // slt (or save my voice) but no data on accent.
                    // if they've paid (voice save) then they should go to the accent page,
                    // otherwise they should go to the page with the 'pay now' button.
                    if (paid) {
                      localStorage.setItem("setStage", "2");
                      nextUrl = "/session/accent";
                    } else {
                      nextUrl = "/speechvault/";
                    }
                  }
                }
              }
            }
          }
          window.document.location.assign(nextUrl);
        })
        .catch(error => console.error(error));
    },
    registerEmail = e => {
      e.preventDefault();
      if (!tsCs) {
        setHaventAgreed(true);
        return;
      }

      const postData = { email: emailNew, recaptcha };

      axios
        .post(registerUrl, postData, axiosConfig)
        .then(response => response.data)
        .then(data => {
          if (!(data && data.ok)) {
            alert("Sorry, an error occurred or that email address is already registered.");
            return;
          }
          const { continuationToken, stage } = data;
          localStorage.setItem("continuationToken", continuationToken);
          localStorage.setItem("stage", stage);
          window.document.location.assign(`${process.env.PUBLIC_URL}/register`);
        })
        .catch(console.error);
    },
    arrowRight = <FontAwesomeIcon
      icon={faArrowRight} style={{ marginLeft: 4 }} />,
    arrowLeft = <FontAwesomeIcon icon={faArrowLeft}
      style={{ marginRight: 4 }} />;

  return (
    <div className="container-full"
      style={{ paddingTop: 17 }}
    >
      <div className="container">
        <div className="columns">
          <div className="column bigBoxes">
            <form onSubmit={registerEmail}>
              <h3 className="title is-3 has-text-centered"> New to SpeakUnique?</h3>
              <div className="has-text-centered" style={{ minHeight: 275 }}>
                <h4 className="title is-4 light">
                  <label htmlFor="emailAddressNew">
                    Start with your email address:
                  </label>
                  <input
                    required
                    type="email"
                    name="emailAddressNewddf"
                    data-hj-whitelist
                    id="emailAddressNew"
                    value={emailNew}
                    onChange={e => setEmailNew(e.target.value)}
                    className="input is-family-primary is-half-width is-text signInEmail"
                  />
                </h4>
                <label htmlFor="tsAndCsAndWesAgrees">
                  <input
                    type="checkbox"
                    className="checkbox tscs"
                    value="okyo"
                    onChange={() => {
                      setHaventAgreed(false);
                      setTcCs(!tsCs);
                    }}
                    style={{ marginRight: '7px' }}
                    id="tsAndCsAndWesAgrees"
                  /> I agree to the <a
                    href="/privacy/"
                    target="_blank"
                    rel="noopener noreferer"
                    className="orange hinted"
                    title="View our Privacy Policy"
                  > privacy policy <FontAwesomeIcon
                      icon={faExternalLinkAlt} title="This link will open in a new window" />
                  </a> and <a
                    href="/su-upload/TermsOfUse.pdf"
                    target="_blank"
                    rel="noopener noreferer"
                    className="orange hinted"
                    title="View our Terms of Use"
                  >
                    terms of use <FontAwesomeIcon
                      icon={faExternalLinkAlt} title="This link will open in a new window" />
                  </a><br />
                  (These links will open in a new window.)
                </label>
                {haventAgreed && (
                  <div className="has-text-centered">
                    Please agree to our <a
                      href="/su-upload/TermsOfUse.pdf"
                      target="_blank"
                      rel="noopener noreferer"
                      title="View our Terms of Use"
                      className="orange hinted"
                    >terms of use <FontAwesomeIcon
                        icon={faExternalLinkAlt} title="This link will open in a new window" /></a> and <a
                          href="/privacy/"
                          rel="noopener noreferer"
                          target="_blank"
                          className="orange hinted"
                          title="View our Privacy Policy"
                        >
                      privacy statement <FontAwesomeIcon
                        icon={faExternalLinkAlt} title="This link will open in a new window" /></a> to register for an account.
                  </div>
                )}
                <br />
                <button
                  type="submit"
                  className="button  buttonPurple buttonBottomCerise"
                  id="signUpButton"
                  style={{ marginTop: 50 }}
                >
                  Begin Registration {arrowRight}
                </button>
              </div>
              <br />
              <div className="columns is-gapless">
                <div className="column">
                  <a href="donor" className="orange hinted">
                    Click here if you have a Voice Donor code
                  </a>
                </div>
                {showVolunteerRegLink ?
                  <div className="column has-text-right">
                    <a href="/we/register-wesu" className="orange hinted">
                      Voice Volunteers click here
                    </a>
                  </div> : null}
              </div>
            </form>
          </div>
          <div className="column bigBoxes">
            <form onSubmit={sendSubmit}>
              <h3 className="title is-3 has-text-centered"> Registered already?</h3>
              <div className="has-text-centered" style={{ minHeight: 275 }}>
                <h4 className="title is-4 light">
                  <label htmlFor="emailAddress">
                    Enter your email address:
                  </label>
                  <input
                    required
                    type="email"
                    data-hj-whitelist
                    name="emailAddressddf"
                    id="emailAddress"
                    value={email}
                    onChange={e => {
                      setEmail(e.target.value);
                      setLoginFailed(false);
                    }}
                    className="input is-half-width is-text is-center is-centered signInEmail"
                  />
                </h4>
                <h4 className="title is-4 light">
                  <label htmlFor="password"> Enter your password: </label>
                  <input
                    type="password"
                    name="passwordddf"
                    id="password"
                    value={password}
                    onChange={e => {
                      setPassword(e.target.value);
                      setLoginFailed(false);
                    }}
                    placeholder=""
                    className="input is-password is-center is-centered signInEmail"
                  />
                </h4>
                <button
                  type="submit"
                  style={{ marginBottom: "18px" }}
                  className="button buttonPurple buttonBottomCerise"
                >
                  Login {arrowRight}
                </button>
              </div>
              <br />
              <a href="forgot" className="orange hinted">
                Forgot your password?
              </a>
              {loginFailed && (
                <div className="has-text-centered">
                  <h4 className="title is-4">Sorry, login failed</h4>
                </div>
              )}
              <ReCaptcha
                sitekey="6LdazMAUAAAAAEoS7OsGk0nmydBBL1V4YykXDD-9"
                action="login"
                verifyCallback={token => setRecaptcha(token)}
              />
            </form>
          </div>
        </div>
        <a href="/">
          <button className="button buttonPurple buttonBottomSandyBrown">
            {arrowLeft} Cancel
          </button>
        </a>
      </div>
    </div>
  );

};

